import SESSION_API from "@/lib/api/Session";
import axios from "axios";
import cookie from "js-cookie";
import jwt_decode from "jwt-decode";
const sessionAPI = new SESSION_API();

const state = {
  token: cookie.get("ut") || "",
  status: "",
  // accessList: cookie.get("al") ? JSON.parse(cookie.get("al")) : ""
  accessList: sessionStorage['al'] ? JSON.parse(sessionStorage['al']) : ""
};

const getters = {
  authStatus: state => {
    // console.log('session#accessList state.status ', JSON.stringify(state.status, null, 4)); 
    return state.status
  },
  isAuthenticated: state => {
    // console.log('session#accessList state.token ', JSON.stringify(state.token, null, 4));
    if(Object.keys(state.accessList).length > 0 && state.token) {
      return true;
    }
    return false;
  },
  userControl: state => {
    const user = state.token ? jwt_decode(state.token) : null;
    return user ? user.controlNumber : null;
  },
  author: state => {
    const user = state.token ? jwt_decode(state.token) : null;
    return user ? `${user.firstName} ${user.lastName}` : null;
  },
  emailAdmin: state => {
    const user = state.token ? jwt_decode(state.token) : null;
    return user ? user.email : null;
  },
  accessList: state => {
    // console.log('session#accessList state.accessList ', JSON.stringify(state.accessList, null, 4)); 
    state.accessList = Object.keys(state.accessList).length > 0 ? [...state.accessList.accessList] : {};
    // if(Object.keys(state.accessList).length === 0) {
    //   state.accessList = [{ "name": "Login", "path": "login" }, { "name": "Home", "path": "/" }, { "name": "Dashboard", "path": "dashboard" }];
    // }
    // console.log('session#accessList state ', JSON.stringify(state.accessList, null, 4));
    // console.log('session#accessList state ', state.accessList);
     return state.accessList;
    // return state.accessList = [
    //   { "name": "Login", "path": "login" }, 
    //   { "name": "Home", "path": "/" }, 
    //   { "name": "Dashboard", "path": "dashboard" },
    //   { "name": "User", "path": "user" },
    //   { "name": "Practitioners", "path": "practitioners" },
    //   { "name": "User Edit", "path": "edit/:controlNumber" },
    //   { "name": "User Manage", "path": "manage" }];

   
  },
  role: state => {
    const user = state.token ? jwt_decode(state.token) : null;
    return user ? `${user.userRole}` : null;
  }
};

const mutations = {
  AUTH_REQUEST: (state, status) => {
    state.status = status;
  },
  AUTH_SUCCESS: (state, token) => {
    state.status = "success";
    state.token = token;
    state.user = jwt_decode(token);
  },
  AUTH_LOGOUT: state => {
    state.token = "";
  },
  ACCESS_LIST: (state, accessList) => {
    state.accessList = accessList;
  }
};

const actions = {
  AUTH_LOGIN: async (context, user) => {
    context.commit("AUTH_REQUEST", "loading");
    // API Call
    try {
      const response = await sessionAPI.login(user);
      const token = `Bearer ${response.access_token}`;
      const expDate = new Date(
        new Date().getTime() + response.role.session.lifeTimeInSeconds * 1000
      );
      cookie.set("ut", token, {
        expires: expDate,
        secure: process.env.NODE_ENV === "production" ? true : false
      });
      const accessListObj = {};
      accessListObj.accessList = response.accessList;

      // const volkswagenSP = {
      //   "path": "volkswagenSP",
      //   "name": "Volkswagen SP"
      // };

      // const utpStudents = {
      //   path: 'utpStudents',
      //   name: 'UTP Students'
      // };

      // const practitioners = {
      //   path: 'practitioners',
      //   name: 'Practitioners'
      // };

      // const extern = {
      //   path: 'extern',
      //   name: 'Extern'
      // };

      // const editExtern = {
      //   path: 'edit/extern/:controlNumber',
      //   name: 'User Extern Edit'
      // };

      // const newExtern = {
      //   path: 'new/extern',
      //   name: 'New Extern User'
      // };

      // accessListObj.accessList.push(
      //   volkswagenSP,
      //   utpStudents,
      //   practitioners,
      //   extern,
      //   editExtern,
      //   newExtern
      // );
      sessionStorage.setItem('al', JSON.stringify(accessListObj));
      axios.defaults.headers.common["Authorization"] = token;
      context.commit("ACCESS_LIST", accessListObj);
      context.commit("AUTH_SUCCESS", token);
    } catch (error) {
      console.log('error: ', error);
      context.commit("AUTH_REQUEST", "error");
      cookie.remove("ut");
      cookie.remove("al");
    }
  },
  AUTH_LOGOUT: async context => {
    context.commit("AUTH_LOGOUT");
    cookie.remove("ut");
    sessionStorage.removeItem('al');
    delete axios.defaults.headers.common["Authorization"];
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
